import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Construction, ArrowLeft } from 'lucide-react';
import { navSections } from '../mock';

export default function PlaceholderPage() {
  const { pathname } = useLocation();
  let label = 'Coming soon';
  for (const s of navSections) {
    const m = s.items.find((i) => i.to === pathname);
    if (m) { label = m.label; break; }
  }

  return (
    <div className="max-w-[900px] mx-auto">
      <div className="text-[11.5px] text-neutral-500 mono">{pathname}</div>
      <h1 className="display text-[32px] font-bold tracking-tight text-neutral-900 mt-1">{label}</h1>

      <div className="mt-8 relative overflow-hidden rounded-2xl border hairline bg-white p-10">
        <div className="absolute inset-0 bg-dot opacity-40" />
        <div className="relative flex items-center gap-5">
          <div className="h-14 w-14 rounded-xl bg-neutral-900 text-[hsl(var(--kf-gold))] flex items-center justify-center">
            <Construction className="h-6 w-6" />
          </div>
          <div>
            <div className="display text-[17px] font-bold text-neutral-900">Module scaffolded</div>
            <p className="text-[13px] text-neutral-600 max-w-xl mt-1">
              This page is part of the Kinfolk CRM blueprint — routing, state, and nav are wired.
              Swap this placeholder for the live module whenever you’re ready.
            </p>
            <Link to="/" className="mt-4 inline-flex items-center gap-1.5 text-[12.5px] font-bold text-neutral-900 gold-underline">
              <ArrowLeft className="h-4 w-4" /> Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
